import { FormattedMessage } from 'gatsby-plugin-intl';
import * as React from 'react';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { useIsRtl } from '../../../hooks/useIsRtl';
import { useTheme } from '../../../hooks/useTheme';
import { media } from '../../../styles/theme';
import { Flex } from '../../common/Flex';
import { Icon } from '../../common/Icon';
import { Indent } from '../../common/Indent';
import { StyledAnchor } from '../../common/StyledLink';
import { StyledText } from '../../common/StyledText';
import { toggleChat, chatIsAvailable } from '../../common/Zopim';

export const ContactUsInfo: React.FC<{}> = () => {
  const theme = useTheme();
  const isRtl = useIsRtl();
  return (
    <Section>
      <Grid>
        <Row reverse={isRtl}>
          <Col xs={12} lg={10} lgOffset={1}>
            <ContactUs>
              <Flex direction='column' align='center'>
                <h2>
                  <StyledText color='textInverted' size='1.8' smSize='2.25' type='block'>
                    <FormattedMessage id='contactUs.title' />
                  </StyledText>
                </h2>
                <Indent vertical={0.5}>
                  <StyledText color='textSecondary' size='1.125' align='center' mdAlign='left' type='inline-block'>
                    <FormattedMessage id='contactUs.lead' />
                  </StyledText>
                </Indent>
                <Indent bottom={1} top={1.5}>
                  <Flex justify='space-between' mdJustify='space-around' direction='column' smDirection='row'>
                    <Indent smHorizontal={1} bottom={1}>
                      <Flex align='center'>
                        <Indent right={1}>
                          <ContactIcon>
                            <Icon name='envelope' color={theme.primaryColor} width='2.2em' />
                          </ContactIcon>
                        </Indent>
                        <StyledText color='textInverted' width='auto'>
                          <StyledAnchor href='mailto:partner@expertoption.com'>partner@expertoption.com</StyledAnchor>
                        </StyledText>
                      </Flex>
                    </Indent>
                    {chatIsAvailable() && (
                      <Indent smHorizontal={1} bottom={1}>
                        <Flex align='center'>
                          <Indent right={1}>
                            <ContactIcon>
                              <Icon name='chat' color={theme.primaryColor} width='2.2em' />
                            </ContactIcon>
                          </Indent>
                          <StyledText color='textInverted' width='auto'>
                            <StyledAnchor
                              href='#'
                              onClick={event => {
                                event.preventDefault();
                                toggleChat.emit();
                              }}>
                              <FormattedMessage id='contactUs.chat' />
                            </StyledAnchor>
                          </StyledText>
                        </Flex>
                      </Indent>
                    )}
                  </Flex>
                </Indent>
              </Flex>
            </ContactUs>
          </Col>
        </Row>
      </Grid>
    </Section>
  );
};

const Section = styled.footer`
  /* background: #20253b; */
`;

export const ContactUs = styled.div`
  background: #313d5b;
  box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  padding: 20px;
  padding-bottom: 0;
  margin-top: -110px;
  margin-bottom: 20px;

  ${media.sm`margin-bottom: 40px;`}
  ${media.md`margin-bottom: 60px;`}
`;

export const ContactIcon = styled.span`
  font-size: 0.5em;

  ${media.sm`font-size: 1em`};
`;
